import styled from 'styled-components';
import { color } from '../../../theme';

export const StyledRequirementsEvolutionGraphic = styled.svg<{
  'data-milestone'?: number;
}>`
  --evolution-fill-default: ${color('mint_900')};
  display: block;
  max-width: 100%;
  height: auto;

  &[data-milestone='1'] {
    .month1 {
      fill: var(--client-primary, var(--evolution-fill-default));
      opacity: 0.25;
    }
    .month3 {
      stroke: transparent;
    }
    .month6 {
      stroke: transparent;
    }
  }
  &[data-milestone='2'] {
    .month1 {
      fill: var(--client-primary, var(--evolution-fill-default));
      opacity: 0.25;
    }
    .month3 {
      fill: var(--client-primary, var(--evolution-fill-default));
      opacity: 0.5;
    }
    .month6 {
      stroke: transparent;
    }
  }

  &[data-milestone='3'] {
    .month1 {
      fill: var(--client-primary, var(--evolution-fill-default));
      opacity: 0.25;
    }
    .month3 {
      fill: var(--client-primary, var(--evolution-fill-default));
      opacity: 0.5;
    }
    .month6 {
      fill: var(--client-primary, var(--evolution-fill-default));
    }
  }
`;
